import { createHttpClient } from 'common/http/HttpClient';
import { CONFIG } from 'constants/config';

export const WebApi = createHttpClient({ baseURL: CONFIG.NEXT_API_URL });
